<select class="form-control" (change)="selectArticle($event)" [(ngModel)]="selectedArticle">
  @for (articleId of selectedForCompare; track articleId; let articleIndex = $index) {
    <option [value]="articleId" [selected]="id === articleId" [disabled]="selected.indexOf(articleId) >= 0">{{availableArticles[articleId]['description']}}
    {{availableArticles[articleId]['caption']}}</option>
  }
</select>
